export function sendTracking(payload) {
  var _window;

  if ((_window = window) === null || _window === void 0 ? void 0 : _window.Lurker) {
    window.Lurker.send(payload);
  } else {
    console.log('LURKER PAYLOAD: ', payload);
  }
}

function formatCategorySuggestionListTracking(categorySuggestions) {
  if (Array.isArray(categorySuggestions)) {
    return categorySuggestions.map(function (suggestion) {
      return {
        query: suggestion.query,
        category_id: suggestion.category_id
      };
    });
  }

  return [];
}

function getCategorySuggestionPosition(suggestionIndex, historySize) {
  return suggestionIndex - historySize;
}

export var formatCategorySuggestionTrackingPayload = function formatCategorySuggestionTrackingPayload(_ref) {
  var typedQuery = _ref.typedQuery,
      suggestion = _ref.suggestion,
      lurkerObjectName = _ref.lurkerObjectName,
      submitMethod = _ref.submitMethod,
      applicationAppliedCategory = _ref.applicationAppliedCategory,
      suggestionIndex = _ref.suggestionIndex,
      categorySuggestions = _ref.categorySuggestions,
      historySize = _ref.historySize;
  var data = {
    query: suggestion.query,
    typed_query: typedQuery,
    method: submitMethod,
    category_id: suggestion.category_id,
    current_category_id: applicationAppliedCategory,
    suggestion_position: getCategorySuggestionPosition(suggestionIndex, historySize),
    suggestion_list: formatCategorySuggestionListTracking(categorySuggestions)
  };

  if (suggestion === null || suggestion === void 0 ? void 0 : suggestion.origin) {
    data.origin = suggestion.origin;
  }

  return {
    event_type: 'click',
    object_detail: 'search_suggestion',
    object_name: lurkerObjectName,
    data: data
  };
};

function formatHistorySuggestionsListTracking(historySuggestions) {
  return Array.isArray(historySuggestions) ? historySuggestions.map(function (suggestion) {
    return suggestion.query;
  }) : [];
}

export var formatHistorySuggestionTrackingPayload = function formatHistorySuggestionTrackingPayload(_ref2) {
  var typedQuery = _ref2.typedQuery,
      suggestion = _ref2.suggestion,
      lurkerObjectName = _ref2.lurkerObjectName,
      submitMethod = _ref2.submitMethod,
      applicationAppliedCategory = _ref2.applicationAppliedCategory,
      suggestionIndex = _ref2.suggestionIndex,
      historySuggestions = _ref2.historySuggestions;
  return {
    event_type: 'click',
    object_detail: 'history_search',
    object_name: lurkerObjectName,
    data: {
      query: suggestion,
      typed_query: typedQuery,
      method: submitMethod,
      current_category_id: applicationAppliedCategory,
      history_position: suggestionIndex,
      history_list: formatHistorySuggestionsListTracking(historySuggestions)
    }
  };
};
export function formatSubmitTrackingPayload(_ref3) {
  var query = _ref3.query,
      lurkerObjectName = _ref3.lurkerObjectName,
      submitMethod = _ref3.submitMethod,
      applicationAppliedCategory = _ref3.applicationAppliedCategory,
      categorySuggestions = _ref3.categorySuggestions,
      historySuggestions = _ref3.historySuggestions;
  return {
    event_type: 'click',
    object_detail: 'search_bar',
    object_name: lurkerObjectName,
    data: {
      query: query,
      suggestion_list: formatCategorySuggestionListTracking(categorySuggestions),
      method: submitMethod,
      current_category_id: applicationAppliedCategory,
      history_list: formatHistorySuggestionsListTracking(historySuggestions)
    }
  };
}
export function getLurkerObjectNameByStyle(inputStyle) {
  if (inputStyle === void 0) {
    inputStyle = '';
  }

  return inputStyle.includes('home') ? 'home' : 'listing';
} // export function formatSubmitTrackingPayload ({
//   query,
//   lurkerObjectName,
//   submitMethod,
//   applicationAppliedCategory,
//   categorySuggestions,
//   historySuggestions
// }) {
//   return {
//     event_type: 'click',
//     object_detail: 'search_bar',
//     object_name: lurkerObjectName,
//     data: {
//       query,
//       suggestion_list: formatCategorySuggestionListTracking(categorySuggestions),
//       method: submitMethod,
//       current_category_id: applicationAppliedCategory,
//       history_list: formatHistorySuggestionsListTracking(historySuggestions)
//     }
//   }
// }